// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_UndoPeriodPreviewResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /payroll/undo_period_preview/{id}
 *
 * Returns a preview of what will be affected by undoing a period.
 * Shows affected counts and whether undo is allowed.
 */
import type { Payroll_UndoPeriodPreviewDataRow } from './Payroll_UndoPeriodPreviewDataRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Payroll_UndoPeriodPreviewResponseDados {
success: boolean
message: string | null
data: Payroll_UndoPeriodPreviewDataRow | null
}

export type Payroll_UndoPeriodPreviewResponse = ApiResponse<Payroll_UndoPeriodPreviewResponseDados>;

registerResponseContract('Payroll_UndoPeriodPreviewResponse', {
  success: { type: 'boolean', required: true },
  message: { type: 'string',  required: false },
  data: {
    type: 'object',
    required: false,
    fields: {
      period: {
        type: 'object',
        required: true,
        fields: {
          id:                { type: 'number',  required: true },
          status:            { type: 'number',  required: true },
          status_label:      { type: 'string',  required: true },
          user_id:           { type: 'string',  required: true },
          period_start_date: { type: 'string',  required: true },
          period_end_date:   { type: 'string',  required: true },
        },
      },
      can_undo: { type: 'boolean', required: true },
      reason:   { type: 'string',  required: false },
      affected: {
        type: 'object',
        required: true,
        fields: {
          executions_count:         { type: 'number',  required: true },
          deductions_count:         { type: 'number',  required: true },
          recebimentos_count:       { type: 'number',  required: true },
          despesas_count:           { type: 'number',  required: true },
          despesas_to_delete_count: { type: 'number',  required: true },
          advances_count:           { type: 'number',  required: true },
        },
      },
    },
  },
})
